import { Component, OnInit, inject } from '@angular/core';
import { CommonFormComponent } from '@ntap/common';
import { ItemViewProviderDirective } from '@ntap/core';
import { Observable, combineLatest, of, take, tap } from 'rxjs';
import { UpravnaStvarService } from './upravna_stvar.service';
import { UpravnoPodrucje } from './upravno_podrucje';

@Component({
  selector: 'app-upravna-stvar-sifrarnik',
  templateUrl: './upravna_stvar.component.html',
  styleUrls: ['./upravna_stvar.component.scss'],
  providers: [UpravnaStvarService]
})
export class UpravnaStvarComponent
  extends CommonFormComponent
  implements OnInit
{
  itemViewProvider = inject(ItemViewProviderDirective);
  upravnaStvarService = inject(UpravnaStvarService);
  upravneStvari$: Observable<any>;
  selectedStvar: object;

  override doChangedInputParam(): void {
    this.initComponentData(this.inputParam);
    this.formControl =
      this.formService.getFormControl(this.formControlName) || this.formControl;
    if (this.inputParam.itemValue !== undefined) {
      this.formControl.setValue(this.inputParam.itemValue);
      this.currentValue = this.inputParam.itemValue;
    }
    this.formControlInitialized = true;
    this.formControl.markAsPristine();
  }

  ngOnInit(): void {
    this.itemViewProvider.item$.pipe(take(1)).subscribe((item) => {
      this.upravneStvari$ = this.upravnaStvarService.getUpravneStvari();
      this.addSubscription(
        combineLatest([of(item), this.upravneStvari$])
          .pipe(
            tap(([item, upravneStvari]: [any, UpravnoPodrucje[]]) => {
              const upravnaStvarId = item['seup~predmet~upravna_stvar_id'];
              this.setValue(upravnaStvarId);
              this.selectedStvar = this.findObjectOfKlasa(
                upravneStvari,
                upravnaStvarId
              );
            })
          )
          .subscribe()
      );
    });
  }

  onNodeSelect(event: any) {
    this.setValue(event.node.key.toString());
  }

  clearSelection() {
    this.formControl.setValue(null);
    this.formControl.markAsDirty();
  }

  setSelectableNodes(nodes: any[], level: number) {
    nodes.forEach((node) => {
      if (level === 2) {
        node.selectable = true;
      } else {
        node.selectable = false;
      }

      if (node.children) {
        this.setSelectableNodes(node.children, level + 1);
      }
    });
  }

  findObjectOfKlasa(stvari: any[], existingStvarId: number | null): any | null {
    if (!existingStvarId) {
      return null;
    }
    for (const stvar of stvari) {
      if (stvar.key == existingStvarId) {
        return stvar;
      }
      if (stvar.children) {
        const found = this.findObjectOfKlasa(stvar.children, existingStvarId);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }
}
